export const TABLE_COLUMNS = 24;
export const TABLE_ROWS = 8;

export const DESKTOP_TRAY_COLUMNS = 24;
export const DESKTOP_TRAY_ROWS = 2;

export const MOBILE_TRAY_COLUMNS = 10;
export const MOBILE_TRAY_ROWS = 3;

export const getTrayLayout = (viewportWidth: number) => {
    if (viewportWidth <= 860) {
        return {
            columns: MOBILE_TRAY_COLUMNS,
            rows: MOBILE_TRAY_ROWS,
        };
    }

    return {
        columns: DESKTOP_TRAY_COLUMNS,
        rows: DESKTOP_TRAY_ROWS,
    };
};

export const getRuntimeTrayLayout = () => {
    if (typeof window === "undefined") {
        return {
            columns: DESKTOP_TRAY_COLUMNS,
            rows: DESKTOP_TRAY_ROWS,
        };
    }

    return getTrayLayout(window.innerWidth);
};

export const getTraySlotFromIndex = (index: number) => {
    const { columns } = getRuntimeTrayLayout();

    return {
        x: index % columns,
        y: Math.floor(index / columns),
    };
};
